import EmployeeAcknowledgementList from '@/components/library/employeeAcknowledgements/EmployeeAcknowledgementList.vue';
import ActiveJobProfiles from '@/components/jobProfiles/ActiveJobProfiles.vue';
import InactiveJobProfiles from '@/components/jobProfiles/InactiveJobProfiles.vue';
import DraftJobProfiles from '@/components/jobProfiles/DraftJobProfiles.vue';
import JobProfileTemplates from '@/components/jobProfiles/JobProfileTemplates.vue';
import JobProfilesLibrary from '@/views/JobProfilesLibrary.vue';
import JobProfileView from '@/views/JobProfileView.vue';
import CreateJobProfileView from '@/views/CreateJobProfileView.vue';
import { jobProfileMiddleware } from '@/helpers/routeMiddleware';

export const jobProfiles = (authDataStore) => ([
  {
    path: '/job-profiles/create',
    name: 'create-job-profile',
    component: CreateJobProfileView,
    beforeEnter: jobProfileMiddleware(authDataStore),
    meta: { title: 'Create Job Profile', parentTitle: 'Job Profiles' },
  },

  {
    path: '/job-profiles/',
    name: 'job-profiles-library',
    component: JobProfilesLibrary,
    beforeEnter: jobProfileMiddleware(authDataStore),
    meta: { title: 'Job Profiles' },
    children: [
      {
        name: 'employee-acknowledgements',
        path: 'employee-acknowledgements',
        component: EmployeeAcknowledgementList,
        meta: { title: 'Employee Acknowledgements', parentTitle: 'Job Profiles' },
      },
      {
        name: 'active-job-profiles',
        path: 'active-job-profiles',
        component: ActiveJobProfiles,
        meta: { title: 'Active Job Profiles', parentTitle: 'Job Profiles' },
      },
      {
        name: 'inactive-job-profiles',
        path: 'inactive-job-profiles',
        component: InactiveJobProfiles,
        meta: { title: 'Inactive Job Profiles', parentTitle: 'Job Profiles' },
      },
      {
        name: 'draft-job-profiles',
        path: 'draft-job-profiles',
        component: DraftJobProfiles,
        meta: { title: 'Draft Job Profiles', parentTitle: 'Job Profiles' },
      },
      {
        name: 'job-profile-templates',
        path: 'job-profile-templates',
        component: JobProfileTemplates,
        meta: { title: 'Job Profile Templates', parentTitle: 'Job Profiles' },
      },
    ],
  },

  {
    path: '/job-profile/:id',
    name: 'job-profile-view',
    props: true,
    meta: {
      title: ({ title } = {}) => ((typeof title === 'string')
        ? title
        : ''),
      parentTitle: 'Job Profiles',
    },
    component: JobProfileView,
    beforeEnter: jobProfileMiddleware(authDataStore),
  },

  {
    path: '/job-profile-hris/:id',
    name: 'job-profile-hris-view',
    props: ({ params }) => ({ isHris: true, id: params.id }),
    meta: {
      title: ({ title } = {}) => ((typeof title === 'string')
        ? title
        : ''),
      parentTitle: 'Job Profiles',
    },
    component: JobProfileView,
    beforeEnter: jobProfileMiddleware(authDataStore),
  },
]);
